import React from 'react';
import { Filter, SelectInput, TextInput, ReferenceInput } from 'react-admin';
import { PROD_STATUSES } from '../../constants';

const CategoriesFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
      <TextInput label="Name" source="name" allowEmpty />
      <SelectInput source="status" choices={PROD_STATUSES} />
      <ReferenceInput
        label="Parent Category"
        source="parent_id"
        reference="categories"
        filter={{ parent_id: null }}
        sort={{ field: 'name', order: 'ASC' }}
        fullWidth
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  );
};
export default CategoriesFilter;
